import React, { useContext } from 'react'
import debounce from '@doveconviene/sf-web-js-sdk/debounce'
import { useSelector, useDispatch } from 'react-redux'
import styled from '@emotion/styled'

import { FilterContext } from '../../../ui/contexts/FilterContext'
import { selectCurrentCategories } from '../../../../flux/selectors/ux'
import { uxEvent } from '../../../../flux/actions/ux'
import Badge from '../../Generics/Badge'
import HorizontalListScroller from '../HorizontalListScroller'

const StyledRoot = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
}))

const StyledList = styled.div(() => ({
  minWidth: '0px',
  flex: ' 1 1 0',
}))

const CategoryListScroller = () => {
  const dispatch = useDispatch()
  const currentCategories = useSelector(selectCurrentCategories)
  const {
    selectedCategories, setSelectedCategories,
  } = useContext(FilterContext)

  const onCategoryClick = debounce(category => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories([...selectedCategories.filter(x => x !== category)])
    } else {
      setSelectedCategories([...selectedCategories, category])
    }

    dispatch(uxEvent({
      name: 'click',
      target: 'CategoryListScroller/Item',
      params: {
        category,
      },
    }))
  }, 150)

  return currentCategories.length ? (
    <StyledRoot>
      <StyledList data-test="CategoryListScroller">
        <HorizontalListScroller scrollWidth={300}>
          <>
            {
              currentCategories.map(category => (
                <Badge
                  dataTest="CategoryListScrollerItem"
                  key={category}
                  active={currentCategories.includes(category)}
                  onClick={() => onCategoryClick(category)}
                >
                  {category}
                </Badge>
              ))
            }
          </>
        </HorizontalListScroller>
      </StyledList>
    </StyledRoot>
  ) : null
}

CategoryListScroller.displayName = 'CategoryListScroller'
CategoryListScroller.whyDidYouRender = true

export default React.memo(CategoryListScroller)
